import CrossIcon from "@dana/Icons/CrossIcon";
import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes } from "@dana/MobiusOverrides/styles/typography";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

export interface ModalSearchSectionStyles {
    wrapper?: InjectableCss;
    searchTextOpenOrder?: TextFieldPresentationProps;
    searchOpenOrderClearButton?: ButtonPresentationProps;
    clearIconOpenModal?: IconPresentationProps;
}

export const modalSearchSectionStyles: ModalSearchSectionStyles = {
    wrapper: {
        css: css`
            position: relative;
            flex: 0 1 500px;

            @media only screen and (max-width: 768px) {
                width: 100%;
                flex: auto;
            }
        `,
    },

    searchTextOpenOrder: {
        cssOverrides: {
            formInputWrapper: css`
                input[type="search"]::-webkit-search-cancel-button {
                    -webkit-appearance: none;
                    appearance: none;
                    display: none;
                }
            `,
            inputSelect: css`
                padding: 8px 20px;
            `,
        },
    },

    searchOpenOrderClearButton: {
        variant: "tertiary",
        css: css`
            position: absolute;
            top: 2%;
            transform: translateX(-40px);
            background: none;
            border: none;
            cursor: pointer;
            padding: 12px;
            margin: 1px;
        `,
    },

    clearIconOpenModal: {
        css: css`
            svg {
                path {
                    fill: ${themeColors.primary.danaBlue};
                }
            }
        `,
    },
};

const styles = modalSearchSectionStyles;

type Props = {
    value: string;
    onChange: (v: string) => void;
    placeholder?: string;
};

const ModalSearchSection: FC<Props> = ({ value, onChange, placeholder }) => {
    const handleClear = () => {
        onChange("");
    };
    return (
        <StyledWrapper {...styles.wrapper}>
            <TextField
                type="search"
                value={value}
                onChange={e => onChange(e.target.value)}
                placeholder={placeholder ?? translate("Search by Part #, Customer Part #, Description, or Line #")}
                aria-label={translate("Search order lines")}
                {...styles.searchTextOpenOrder}
            />
            {value && (
                <Button onClick={handleClear} aria-label="Clear search input" {...styles.searchOpenOrderClearButton}>
                    <Icon src={CrossIcon} size={13} {...styles.clearIconOpenModal} />
                </Button>
            )}
        </StyledWrapper>
    );
};

export default ModalSearchSection;
